import { render, staticRenderFns } from "./EditServiceList.vue?vue&type=template&id=0bd703cc"
import script from "./EditServiceList.vue?vue&type=script&lang=js"
export * from "./EditServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports